/**
 * VixoKart Theme — Wishlist Page
 * Renders products saved in localStorage by VixoKart.Wishlist (theme.js).
 */

'use strict';

(function () {
  const grid = document.getElementById('wishlist-grid');
  const empty = document.getElementById('wishlist-empty');
  const subcount = document.getElementById('wishlist-subcount');
  if (!grid) return;

  function render() {
    const items = (window.VixoKart && VixoKart.Wishlist) ? VixoKart.Wishlist.getAll() : [];

    if (subcount) {
      subcount.textContent = items.length
        ? `${items.length} item${items.length === 1 ? '' : 's'} saved`
        : '';
    }

    if (!items.length) {
      grid.innerHTML = '';
      empty?.classList.remove('hidden');
      return;
    }

    empty?.classList.add('hidden');

    grid.innerHTML = items.map(item => `
      <div class="product-card" data-wishlist-page-item="${item.id}">
        <a class="product-card__link" href="${item.url || '#'}" aria-label="${item.title || ''}">
          <div class="product-card__image-wrap ratio-portrait">
            ${item.image
              ? `<img class="product-card__img" src="${item.image}" alt="${item.title || ''}" width="300" height="375" loading="lazy">`
              : ''}
          </div>
        </a>
        <button
          class="product-card__wishlist active"
          data-wishlist-remove="${item.id}"
          aria-label="Remove ${item.title || 'item'} from wishlist"
          type="button"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
          </svg>
        </button>
        <a class="product-card__title" href="${item.url || '#'}">${item.title || 'Untitled product'}</a>
        <div class="product-card__price">
          <span class="product-card__price-current">${item.price || ''}</span>
        </div>
      </div>
    `).join('');

    grid.querySelectorAll('[data-wishlist-remove]').forEach(btn => {
      btn.addEventListener('click', () => {
        const id = btn.dataset.wishlistRemove;
        if (window.VixoKart && VixoKart.Wishlist) {
          VixoKart.Wishlist.toggle({ id });
        }
        render();
      });
    });
  }

  render();
})();
